import React, { useEffect, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import styled from "styled-components";

import { State } from "src/state/ducks";
import * as NotificationActions from "src/state/ducks/notification/actions";

import { formatDateAsQuery } from "src/helpers/UtilityHelper";
import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps, HistoryProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import HomeButton from "src/components/atoms/button/HomeButton";
import SpinnerModal from "src/components/organisms/loading/SpinnerModal";
import DatePickerForm from "src/components/organisms/form/DatePickerForm";

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const OrderBread = (props: Props) => {
  const {
    notifications,
    login_shop_id: currentShopId,
    getNotificatons,
    isFetching,
    history,
  } = props;

  useEffect(() => {
    getNotificatons(currentShopId);
  }, [currentShopId, getNotificatons]);

  const days = useMemo(
    () => notifications.map((_) => formatDateAsQuery(_.created_at.toDate())),
    [notifications]
  );

  const onNext = useCallback(
    (date: Date | undefined) => {
      history.push(
        `/shop/${currentShopId}/search/order_breads/${formatDateAsQuery(date)}`
      );
    },
    [currentShopId, history]
  );

  return (
    <DefaultLayout {...props}>
      <SpinnerModal isLoading={isFetching} />
      <Container>
        <Heading tag="h1" text="配信履歴を確認する" />
        <p className="lead">
          配信履歴を確認したい日付を選択してください
          <br />
          ※灰色の日は焼き上がりの通知を行っていません
        </p>
        <div className="item">
          <DatePickerForm onNext={onNext} selectableDays={days} />
        </div>
        <div className="item">
          <HomeButton />
        </div>
      </Container>
    </DefaultLayout>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  > .lead {
    font-size: 12px;
  }
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
`;

const mapStateToProps = (state: State) => ({
  notifications: state.notification.resource.map((v) => {
    return {
      id: v.id,
      is_notified: v.is_notified,
      created_at: v.created_at,
    };
  }),
  isFetching: state.notification.isFetching,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getNotificatons: (id: string) =>
    dispatch(NotificationActions.getNotifications({ shopId: id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderBread);
